import { getViewportHeight, getViewportWidth } from './helper';

export default class hpyGlobals {
	constructor() {
		this.isMobile = false;
		this.mobileBreakpoint = 'md';
		this.breakpoints = false;
		this.timer = false;

		this.calculateBreakpoints();
		this.addEvents();
	}

	addEvents() {
		this.resizeEvents();
	}

	initBreakpoints() {
		if (undefined === window.hpy_sizes) {
			return;
		}

		this.breakpoints = window.hpy_sizes;
		this.breakpoints.breakpoints = {};

		for (let bp in this.breakpoints) {
			if ('breakpoints' !== bp) {
				this.breakpoints.breakpoints[bp] = {
					bp: parseInt(this.breakpoints[bp])
				}
				delete this.breakpoints[bp];
			}
		}
	}

	calculateBreakpoints() {
		if (!this.breakpoints) {
			this.initBreakpoints();
		}

		this.breakpoints.height = getViewportHeight();
		this.breakpoints.width = getViewportWidth();

		for (let bp in this.breakpoints.breakpoints) {
			this.breakpoints.breakpoints[bp].min = this.breakpoints.width >= this.breakpoints.breakpoints[bp].bp ? true : false;
			this.breakpoints.breakpoints[bp].max = this.breakpoints.width < this.breakpoints.breakpoints[bp].bp ? true : false;
		}

		this.isMobile = this.breakpoints.breakpoints?.[this.mobileBreakpoint].max;
	}

	resizeEvents() {
		window.addEventListener("resize", () => {
			clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				this.calculateBreakpoints();
			}, 250);
		});
	}

	isBreakpoint(bp, min = false) {
		if (min) {
			return this.breakpoints.breakpoints?.[bp]?.min;
		} else {
			return this.breakpoints.breakpoints?.[bp]?.max;
		}

	}

}